module.exports = __webpack_public_path__ + "static/boxes-be82d4694e0d22bc106549419685ff22.png";